var _excluded = ["fileAdded", "title", "thumbnailUrl", "variant", "progress", "onClick", "onCancel", "errorMessage", "cancelLabel"],
    _excluded2 = ["errorMessage", "variant"],
    _excluded3 = ["accept", "multiple", "onClick", "onChange"];

function cov_k3pgh4cdu() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/sell/UploadCard/UploadCard.tsx";
  var hash = "4923ba52fed1b11e3c0df6bcc09414882c54b29d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/sell/UploadCard/UploadCard.tsx",
    statementMap: {
      "0": {
        start: {
          line: 53,
          column: 67
        },
        end: {
          line: 155,
          column: 1
        }
      },
      "1": {
        start: {
          line: 66,
          column: 46
        },
        end: {
          line: 69,
          column: 3
        }
      },
      "2": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 27
        }
      },
      "3": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 24
        }
      },
      "4": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 154,
          column: 4
        }
      },
      "5": {
        start: {
          line: 81,
          column: 23
        },
        end: {
          line: 81,
          column: 43
        }
      },
      "6": {
        start: {
          line: 159,
          column: 66
        },
        end: {
          line: 176,
          column: 1
        }
      },
      "7": {
        start: {
          line: 164,
          column: 2
        },
        end: {
          line: 175,
          column: 4
        }
      },
      "8": {
        start: {
          line: 184,
          column: 57
        },
        end: {
          line: 227,
          column: 1
        }
      },
      "9": {
        start: {
          line: 191,
          column: 25
        },
        end: {
          line: 191,
          column: 62
        }
      },
      "10": {
        start: {
          line: 192,
          column: 48
        },
        end: {
          line: 199,
          column: 3
        }
      },
      "11": {
        start: {
          line: 193,
          column: 4
        },
        end: {
          line: 196,
          column: 5
        }
      },
      "12": {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 195,
          column: 40
        }
      },
      "13": {
        start: {
          line: 197,
          column: 4
        },
        end: {
          line: 197,
          column: 62
        }
      },
      "14": {
        start: {
          line: 198,
          column: 4
        },
        end: {
          line: 198,
          column: 26
        }
      },
      "15": {
        start: {
          line: 200,
          column: 2
        },
        end: {
          line: 226,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 53,
            column: 67
          },
          end: {
            line: 53,
            column: 68
          }
        },
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 155,
            column: 1
          }
        },
        line: 64
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 66,
            column: 46
          },
          end: {
            line: 66,
            column: 47
          }
        },
        loc: {
          start: {
            line: 66,
            column: 53
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 66
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 81,
            column: 17
          },
          end: {
            line: 81,
            column: 18
          }
        },
        loc: {
          start: {
            line: 81,
            column: 23
          },
          end: {
            line: 81,
            column: 43
          }
        },
        line: 81
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 159,
            column: 66
          },
          end: {
            line: 159,
            column: 67
          }
        },
        loc: {
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 175,
            column: 4
          }
        },
        line: 164
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 184,
            column: 57
          },
          end: {
            line: 184,
            column: 58
          }
        },
        loc: {
          start: {
            line: 190,
            column: 6
          },
          end: {
            line: 227,
            column: 1
          }
        },
        line: 190
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 192,
            column: 48
          },
          end: {
            line: 192,
            column: 49
          }
        },
        loc: {
          start: {
            line: 192,
            column: 55
          },
          end: {
            line: 199,
            column: 3
          }
        },
        line: 192
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 81
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 56,
            column: 17
          },
          end: {
            line: 56,
            column: 81
          }
        }],
        line: 56
      },
      "1": {
        loc: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 57,
            column: 12
          },
          end: {
            line: 57,
            column: 23
          }
        }],
        line: 57
      },
      "2": {
        loc: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 62,
            column: 16
          },
          end: {
            line: 62,
            column: 24
          }
        }],
        line: 62
      },
      "3": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 12
          }
        }, {
          start: {
            line: 67,
            column: 16
          },
          end: {
            line: 67,
            column: 26
          }
        }],
        line: 67
      },
      "4": {
        loc: {
          start: {
            line: 72,
            column: 25
          },
          end: {
            line: 72,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 37
          },
          end: {
            line: 72,
            column: 47
          }
        }, {
          start: {
            line: 72,
            column: 50
          },
          end: {
            line: 72,
            column: 52
          }
        }],
        line: 72
      },
      "5": {
        loc: {
          start: {
            line: 81,
            column: 23
          },
          end: {
            line: 81,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 81,
            column: 23
          },
          end: {
            line: 81,
            column: 30
          }
        }, {
          start: {
            line: 81,
            column: 34
          },
          end: {
            line: 81,
            column: 43
          }
        }],
        line: 81
      },
      "6": {
        loc: {
          start: {
            line: 90,
            column: 9
          },
          end: {
            line: 135,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 91,
            column: 10
          },
          end: {
            line: 93,
            column: 17
          }
        }, {
          start: {
            line: 95,
            column: 10
          },
          end: {
            line: 134,
            column: 17
          }
        }],
        line: 90
      },
      "7": {
        loc: {
          start: {
            line: 96,
            column: 13
          },
          end: {
            line: 105,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 13
          },
          end: {
            line: 96,
            column: 25
          }
        }, {
          start: {
            line: 97,
            column: 14
          },
          end: {
            line: 104,
            column: 16
          }
        }],
        line: 96
      },
      "8": {
        loc: {
          start: {
            line: 116,
            column: 17
          },
          end: {
            line: 126,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 17
          },
          end: {
            line: 116,
            column: 26
          }
        }, {
          start: {
            line: 117,
            column: 18
          },
          end: {
            line: 125,
            column: 20
          }
        }],
        line: 116
      },
      "9": {
        loc: {
          start: {
            line: 128,
            column: 15
          },
          end: {
            line: 132,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 128,
            column: 15
          },
          end: {
            line: 128,
            column: 37
          }
        }, {
          start: {
            line: 128,
            column: 41
          },
          end: {
            line: 128,
            column: 51
          }
        }, {
          start: {
            line: 129,
            column: 16
          },
          end: {
            line: 131,
            column: 22
          }
        }],
        line: 128
      },
      "10": {
        loc: {
          start: {
            line: 137,
            column: 7
          },
          end: {
            line: 152,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 7
          },
          end: {
            line: 137,
            column: 15
          }
        }, {
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 151,
            column: 15
          }
        }],
        line: 137
      },
      "11": {
        loc: {
          start: {
            line: 170,
            column: 17
          },
          end: {
            line: 170,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 170,
            column: 32
          },
          end: {
            line: 170,
            column: 33
          }
        }, {
          start: {
            line: 170,
            column: 36
          },
          end: {
            line: 170,
            column: 45
          }
        }],
        line: 170
      },
      "12": {
        loc: {
          start: {
            line: 171,
            column: 17
          },
          end: {
            line: 171,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 171,
            column: 32
          },
          end: {
            line: 171,
            column: 39
          }
        }, {
          start: {
            line: 171,
            column: 42
          },
          end: {
            line: 171,
            column: 51
          }
        }],
        line: 171
      },
      "13": {
        loc: {
          start: {
            line: 172,
            column: 15
          },
          end: {
            line: 172,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 172,
            column: 30
          },
          end: {
            line: 172,
            column: 36
          }
        }, {
          start: {
            line: 172,
            column: 39
          },
          end: {
            line: 172,
            column: 48
          }
        }],
        line: 172
      },
      "14": {
        loc: {
          start: {
            line: 173,
            column: 17
          },
          end: {
            line: 173,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 173,
            column: 32
          },
          end: {
            line: 173,
            column: 39
          }
        }, {
          start: {
            line: 173,
            column: 42
          },
          end: {
            line: 173,
            column: 51
          }
        }],
        line: 173
      },
      "15": {
        loc: {
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 193
      },
      "16": {
        loc: {
          start: {
            line: 197,
            column: 4
          },
          end: {
            line: 197,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 197,
            column: 4
          },
          end: {
            line: 197,
            column: 27
          }
        }, {
          start: {
            line: 197,
            column: 31
          },
          end: {
            line: 197,
            column: 61
          }
        }],
        line: 197
      },
      "17": {
        loc: {
          start: {
            line: 198,
            column: 4
          },
          end: {
            line: 198,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 198,
            column: 4
          },
          end: {
            line: 198,
            column: 11
          }
        }, {
          start: {
            line: 198,
            column: 15
          },
          end: {
            line: 198,
            column: 25
          }
        }],
        line: 198
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4923ba52fed1b11e3c0df6bcc09414882c54b29d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_k3pgh4cdu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_k3pgh4cdu();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef } from 'react';
import { Icon, Flex, Text, Button, Card, Box, Image, InputBase } from '@opendoor/bricks/core';
import { ProgressBar, Chip } from '@opendoor/bricks/complex';
cov_k3pgh4cdu().s[0]++;

/**
 * Shared upload card that renders a file upload UI.
 * Design: https://www.figma.com/file/w3nEyANoniTZdjz8kCUaDS/Eero-Design-System?node-id=4705%3A15564.
 */
export var UploadCard = function UploadCard(_ref) {
  var fileAdded = _ref.fileAdded,
      title = _ref.title,
      _ref$thumbnailUrl = _ref.thumbnailUrl,
      thumbnailUrl = _ref$thumbnailUrl === void 0 ? (cov_k3pgh4cdu().b[0][0]++, 'https://imgdrop.imgix.net/7337b6da53c64b4db51017b4f3ed7964.png') : _ref$thumbnailUrl,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? (cov_k3pgh4cdu().b[1][0]++, 'secondary') : _ref$variant,
      progress = _ref.progress,
      _onClick = _ref.onClick,
      onCancel = _ref.onCancel,
      errorMessage = _ref.errorMessage,
      _ref$cancelLabel = _ref.cancelLabel,
      cancelLabel = _ref$cancelLabel === void 0 ? (cov_k3pgh4cdu().b[2][0]++, 'Cancel') : _ref$cancelLabel,
      marginProps = _objectWithoutProperties(_ref, _excluded);

  cov_k3pgh4cdu().f[0]++;
  cov_k3pgh4cdu().s[1]++;

  // TODO - Div's should not have onClick events
  var onCancelClick = function onCancelClick(e) {
    cov_k3pgh4cdu().f[1]++;
    cov_k3pgh4cdu().s[2]++;
    (cov_k3pgh4cdu().b[3][0]++, onCancel) && (cov_k3pgh4cdu().b[3][1]++, onCancel());
    cov_k3pgh4cdu().s[3]++;
    e.stopPropagation();
  };

  cov_k3pgh4cdu().s[4]++;
  return /*#__PURE__*/React.createElement(CardContainer, _extends({
    title: "Card for ".concat(fileAdded ? (cov_k3pgh4cdu().b[4][0]++, 'uploaded') : (cov_k3pgh4cdu().b[4][1]++, ''), " file ").concat(title),
    variant: variant,
    errorMessage: errorMessage
  }, marginProps), /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    "aria-label": "View the file ".concat(title),
    analyticsName: "cake-upload-card",
    onClick: function onClick() {
      cov_k3pgh4cdu().f[2]++;
      cov_k3pgh4cdu().s[5]++;
      return (cov_k3pgh4cdu().b[5][0]++, _onClick) && (cov_k3pgh4cdu().b[5][1]++, _onClick());
    },
    flex: "1",
    py: [6, 7, 7],
    pl: [7, 7, 7],
    pr: [4, 4, 4] // The ghost variant adds a background color on hover to its children
    // This removes this background color
    ,
    sx: {
      '&>*:hover': {
        backgroundColor: 'unset'
      }
    }
  }, errorMessage ? (cov_k3pgh4cdu().b[6][0]++, /*#__PURE__*/React.createElement(Text, {
    color: "red50",
    fontSize: "s1",
    fontWeight: "semibold"
  }, errorMessage)) : (cov_k3pgh4cdu().b[6][1]++, /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 1,
    alignItems: "center",
    gridGap: 5
  }, (cov_k3pgh4cdu().b[7][0]++, thumbnailUrl) && (cov_k3pgh4cdu().b[7][1]++, /*#__PURE__*/React.createElement(Image, {
    src: thumbnailUrl,
    alt: "Thumbnail",
    width: [48, null, 56],
    height: [48, null, 56],
    objectFit: "cover",
    borderRadius: "squared"
  })), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "start",
    flexDirection: "column",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: ['start', null, 'center'],
    flexDirection: ['column', null, 'row'],
    width: "100%",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "s1",
    lineHeight: "s00",
    wordBreak: "break-word",
    textAlign: "start"
  }, title), (cov_k3pgh4cdu().b[8][0]++, fileAdded) && (cov_k3pgh4cdu().b[8][1]++, /*#__PURE__*/React.createElement(Chip, {
    rightIcon: {
      name: 'checkmark',
      color: 'neutrals0'
    },
    borderColor: "green50",
    backgroundColor: "green50",
    text: "Done",
    textColor: "neutrals0",
    mt: [1, null, 0],
    ml: [0, null, 6]
  }))), (cov_k3pgh4cdu().b[9][0]++, progress !== undefined) && (cov_k3pgh4cdu().b[9][1]++, !fileAdded) && (cov_k3pgh4cdu().b[9][2]++, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    mt: 4
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    progress: progress,
    gradientProgress: false,
    thickness: 4
  }))))))), (cov_k3pgh4cdu().b[10][0]++, onCancel) && (cov_k3pgh4cdu().b[10][1]++, /*#__PURE__*/React.createElement(Flex, {
    as: "button",
    cursor: "pointer",
    "aria-label": cancelLabel // Touch targets should be at least 48x48
    ,
    width: "48px",
    height: "48px",
    pl: "0",
    alignItems: "center",
    justifyContent: "center",
    onClick: onCancelClick
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: 12,
    "aria-hidden": true
  }))));
};
cov_k3pgh4cdu().s[6]++;

var CardContainer = function CardContainer(_ref2) {
  var errorMessage = _ref2.errorMessage,
      variant = _ref2.variant,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  cov_k3pgh4cdu().f[3]++;
  cov_k3pgh4cdu().s[7]++;
  return /*#__PURE__*/React.createElement(Card, _extends({
    display: "flex",
    flexDir: "row",
    alignItems: "center",
    variant: variant,
    p: [0, 0, 0],
    borderWidth: errorMessage ? (cov_k3pgh4cdu().b[11][0]++, 2) : (cov_k3pgh4cdu().b[11][1]++, undefined),
    borderColor: errorMessage ? (cov_k3pgh4cdu().b[12][0]++, 'red50') : (cov_k3pgh4cdu().b[12][1]++, undefined),
    boxShadow: errorMessage ? (cov_k3pgh4cdu().b[13][0]++, 'none') : (cov_k3pgh4cdu().b[13][1]++, undefined),
    borderStyle: errorMessage ? (cov_k3pgh4cdu().b[14][0]++, 'solid') : (cov_k3pgh4cdu().b[14][1]++, undefined)
  }, rest));
};

cov_k3pgh4cdu().s[8]++;

/** eslint-disable-next-line jsdoc/require-jsdoc */
export var UploadButton = function UploadButton(_ref3) {
  var accept = _ref3.accept,
      multiple = _ref3.multiple,
      onClick = _ref3.onClick,
      onChange = _ref3.onChange,
      buttonProps = _objectWithoutProperties(_ref3, _excluded3);

  cov_k3pgh4cdu().f[4]++;
  var hiddenInputRef = (cov_k3pgh4cdu().s[9]++, useRef(null));
  cov_k3pgh4cdu().s[10]++;

  var onButtonClick = function onButtonClick(e) {
    cov_k3pgh4cdu().f[5]++;
    cov_k3pgh4cdu().s[11]++;

    if (hiddenInputRef !== null && hiddenInputRef !== void 0 && hiddenInputRef.current) {
      cov_k3pgh4cdu().b[15][0]++;
      cov_k3pgh4cdu().s[12]++;
      // Allows selecting the same file to trigger onChange.
      hiddenInputRef.current.value = '';
    } else {
      cov_k3pgh4cdu().b[15][1]++;
    }

    cov_k3pgh4cdu().s[13]++;
    (cov_k3pgh4cdu().b[16][0]++, hiddenInputRef === null || hiddenInputRef === void 0 ? void 0 : hiddenInputRef.current) && (cov_k3pgh4cdu().b[16][1]++, hiddenInputRef.current.click());
    cov_k3pgh4cdu().s[14]++;
    (cov_k3pgh4cdu().b[17][0]++, onClick) && (cov_k3pgh4cdu().b[17][1]++, onClick(e));
  };

  cov_k3pgh4cdu().s[15]++;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputBase, {
    "aria-hidden": true,
    ref: hiddenInputRef,
    type: "file" // NOTE: See accessibility safe hiding of content
    // https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/
    ,
    style: {
      border: 0,
      clipPath: 'rect(1px, 1px, 1px, 1px)',
      height: '1px',
      width: '1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      whiteSpace: 'nowrap'
    },
    accept: accept,
    onChange: onChange,
    multiple: multiple
  }), /*#__PURE__*/React.createElement(Button, _extends({}, buttonProps, {
    onClick: onButtonClick
  })));
};